import { Commit, VcsProvider } from "types/generated";
import { providerHasVcsHost } from "utils/vcs";

export const getPushCommitUrl = (
  sha: string,
  headCommit: Pick<Commit, "hash" | "url">,
  provider: VcsProvider
): string | undefined => {
  if (!providerHasVcsHost(provider)) {
    return undefined;
  }

  if (sha === headCommit.hash) {
    return headCommit.url;
  }

  if (!headCommit.url.includes(headCommit.hash)) {
    return undefined;
  }

  return headCommit.url.replace(headCommit.hash, sha);
};
